import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlanningsApi } from "../../http/carPlannings/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import CarPlanningForm, { CarPlanningFormBody } from "./CarPlanningForm";

const NewCarPlanning: FC = () => {
  const navigate = useNavigate();
  const i18n = useI18n();
  const carPlanningsApi = useCarPlanningsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async function (data: CarPlanningFormBody) {
    setIsSubmitting(true);
    try {
      const response = await carPlanningsApi.insertAdminCarPlanning({
        year: data.year,
        nr: data.nr,
        driverName: data.driverName,
        managerName: data.managerName,
        costCenter: data.costCenter,
        startDate: data.startDate,
        carArrivalDate: data.carArrivalDate,
        subsidiaryId: data.subsidiary.id,
        status: data.state?.value,
        type: data.type?.value,
        priceWithoutVat: data.priceWithoutVat,
      });
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/car_plannings/${response.id}`);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.carPlannings.new} />
      <Panel>
        <CarPlanningForm onSubmit={onSubmit} isDisabled={isSubmitting}></CarPlanningForm>
      </Panel>
    </>
  );
};

export default NewCarPlanning;
